var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-verification-waiting"},[_c('div',{staticClass:"modal-verification-waiting__sign"},[_c('icon',{attrs:{"name":"warning"}})],1),_c('div',{staticClass:"modal-verification-waiting__text"},[_vm._v(" Дождитесь подтверждения верификации ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }